module.exports = __webpack_public_path__ + "static/materialAlpha-84d5f3eca65dea5ea6b843a0b30a0422.jpg";